module.exports = __webpack_public_path__ + "static/media/BANNERSPORTBULL.f96acdfe.jpg";